const columns = [
  {
    title: "Nomor Akun",
    dataIndex: "noAcc",
    key: "noAcc",
    render: (text) => <a>{text}</a>,
  },
  {
    title: "Nama Akun",
    dataIndex: "nameAcc",
    key: "nameAcc",
  },
  {
    title: "Kode",
    dataIndex: "kode",
    key: "kode",
  },
  {
    title: "Kolom",
    dataIndex: "kolom",
    key: "kolom",
  },
  {
    title: "Keterangan",
    dataIndex: "keterangan",
    key: "keterangan",
  },
];

const dataForm = [
  [
    {
      label: "Nomor Akun",
      key: "noAcc",
      placeholder: "Nomor Akun Anda",
      type: "text",
    },
    {
      label: "Nama Akun",
      key: "nameAcc",
      placeholder: "Nama Akun",
      type: "text",
    },
  ],
  [
    {
      label: "Kode",
      key: "kode",
      placeholder: "Kode",
      type: "text",
    },
    {
      label: "Kolom",
      key: "kolom",
      placeholder: "Kolom",
      type: "number",
    },
  ],
  {
    label: "Keterangan",
    key: "keterangan",
    placeholder: "Keterangan",
    type: "textarea",
  },
];

export { columns, dataForm };
